var _style, _path, _path2, _path3, _path4, _g, _g2, _g3, _g4, _g5, _defs, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHaberturk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 173.4 82.7",
    style: {
      enableBackground: "new 0 0 173.4 82.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st1{clip-path:url(#SVGID_2_);fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0h10.2v11.6h11.2V0h10.3v33.1H21.4V19.7H10.2v13.4H0V0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.1,27.7H46.4l-1.6,5.5H34.4L46.8,0H58l12.4,33.1H59.7L58.1,27.7z M55.9,20.5L52.3,8.6l-3.6,11.9H55.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.9,0h19.2c3.2,0,5.6,0.8,7.3,2.4c1.7,1.6,2.6,3.5,2.6,5.9c0,2-0.6,3.6-1.8,5c-0.8,0.9-2,1.7-3.6,2.2 c2.4,0.6,4.1,1.6,5.2,3c1.1,1.4,1.7,3.1,1.7,5.2c0,1.7-0.4,3.3-1.2,4.6s-1.9,2.5-3.3,3.3c-0.9,0.5-2.2,0.9-3.9,1.1 c-2.3,0.3-3.8,0.4-4.6,0.4H72.9V0z M83.2,13h4.5c1.6,0,2.7-0.3,3.3-0.8c0.6-0.6,0.9-1.4,0.9-2.4c0-1-0.3-1.7-0.9-2.3 c-0.6-0.5-1.7-0.8-3.3-0.8h-4.5V13z M83.2,26h5.2c1.8,0,3-0.3,3.7-0.9c0.7-0.6,1.1-1.5,1.1-2.5c0-1-0.4-1.8-1.1-2.3 c-0.7-0.6-2-0.9-3.8-0.9h-5.2V26"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.1,0h27.4v7.1h-17.2v5.3h15.9v6.8h-15.9v6.5H136v7.5h-27.9V0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.8,33.1V0h17.1c3.2,0,5.6,0.3,7.2,0.8s3,1.6,4,3c1,1.5,1.5,3.2,1.5,5.4c0,1.8-0.4,3.4-1.2,4.8 c-0.8,1.3-1.9,2.4-3.2,3.2c-0.9,0.5-2.1,1-3.6,1.3c1.2,0.4,2.1,0.8,2.7,1.2c0.4,0.3,0.9,0.9,1.6,1.7c0.7,0.9,1.2,1.6,1.4,2.1 l4.9,9.6h-11.6L156.4,23c-0.7-1.3-1.3-2.2-1.9-2.6c-0.7-0.5-1.6-0.8-2.5-0.8h-0.9v13.4H140.8z M151.1,13.4h4.3 c0.5,0,1.4-0.2,2.7-0.5c0.7-0.1,1.2-0.5,1.6-1c0.4-0.6,0.7-1.2,0.7-1.9c0-1.1-0.3-1.9-1-2.5c-0.7-0.6-1.9-0.9-3.8-0.9h-4.5V13.4"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,49h31.1v8.2H20.7v24.9H10.5V57.2H0V49"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.6,49h10.2v19.7c0,2-0.3,3.8-0.9,5.6c-0.6,1.7-1.6,3.3-2.9,4.6c-1.3,1.3-2.7,2.2-4.1,2.7 c-2,0.7-4.4,1.1-7.2,1.1c-1.6,0-3.4-0.1-5.3-0.3c-1.9-0.2-3.5-0.7-4.8-1.3c-1.3-0.7-2.5-1.6-3.5-2.9c-1.1-1.2-1.8-2.5-2.2-3.8 c-0.6-2.1-0.9-4-0.9-5.6V49h10.2v20.2c0,1.8,0.5,3.2,1.5,4.2c1,1,2.4,1.5,4.2,1.5c1.8,0,3.1-0.5,4.1-1.5c1-1,1.5-2.4,1.5-4.3V49"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93,82.1V49h17.1c3.2,0,5.6,0.3,7.3,0.8c1.7,0.5,3,1.6,4,3c1,1.5,1.5,3.2,1.5,5.4c0,1.8-0.4,3.4-1.2,4.8 c-0.8,1.3-1.9,2.4-3.2,3.2c-0.9,0.5-2.1,1-3.6,1.3c1.2,0.4,2.1,0.8,2.7,1.2c0.4,0.3,0.9,0.9,1.6,1.7c0.7,0.9,1.2,1.6,1.4,2.1 l5,9.6h-11.6L108.6,72c-0.7-1.3-1.3-2.2-1.9-2.6c-0.7-0.5-1.6-0.8-2.5-0.8h-0.9v13.4H93z M103.3,62.4h4.3c0.5,0,1.4-0.1,2.7-0.4 c0.7-0.1,1.2-0.5,1.7-1c0.4-0.6,0.7-1.2,0.7-1.9c0-1.1-0.3-1.9-1-2.5c-0.7-0.6-1.9-0.9-3.8-0.9h-4.5V62.4"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.3,49h10.2v12.5L159.2,49h13.6l-12.1,12.5l12.6,20.6h-12.6l-7-13.6l-5.3,5.5v8.1h-10.2V49"
  })))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 37,
    width: 173.4,
    height: 8
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,37.1h173.4v7.6H0V37.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaberturk);
export default __webpack_public_path__ + "static/media/haberturk.db2919a6307fba6cca1e6961d1894248.svg";
export { ForwardRef as ReactComponent };